import request from '@/utils/request'
import requestJson from "@/utils/requestJson"

export function stockItemGetStockList(data) {
  return request({
    url: '/admin/shop_stock_item/getNewStockList',
    method: 'get',
    params: data
  })
}

export function stockItemGetShopStock(data) {
  return request({
    url: '/admin/shop_stock_item/getStockDetail',
    method: 'get',
    params: data
  })
}

// 盘库记录
export function getStockTakeList(data) {
  return request({
    url: '/admin/shop_stock_item/getStockTakeList',
    method: 'get',
    params: data
  })
}

// 日常盘库
export function takeStockList(data) {
  return request({
    url: '/admin/shop_stock_item/takeStockList',
    method: 'get',
    params: data
  })
}

// 盘库逾期
export function overdueStockList(data) {
  return request({
    url: '/admin/shop_stock_item/overdueStockList',
    method: 'get',
    params: data
  })
}

// 更新
export function updateStock(data) {
  return request({
    url: '/admin/shop_stock_item/updateStock',
    method: 'post',
    data
  })
}

// 批量更新
export function batchUpdateShopStock(data) {
  return requestJson({
    url: '/admin/shop_stock_item/batchUpdateShopStock',
    method: 'post',
    data
  })
}

// 一键无误
export function upAllCheckOK(data) {
  return requestJson({
    url: '/admin/shop_stock_item/upAllCheckOK',
    method: 'get',
    params:data
  })
}

// 同步总库存
export function updateShopStockByItem(data) {
  return requestJson({
    url: '/admin/Shop_stock_item/updateShopStockByItem',
    method: 'get',
    params:data
  })
}

// 目标库存列表
export function getTargetStockList(data) {
  return request({
    url: '/admin/Stock_target/get_list',
    method: 'get',
    params: data
  })
}


// 保存目标/安全库存（单条或批量）
export function saveTargets(data) {
  // 后端通过 get_post 取值，需要表单方式；批量 items 需为 JSON 字符串
  return request({
    url: '/admin/Stock_target/save_targets',
    method: 'post',
    data
  })
}

// 初始化目标库存
export function initTargets(data) {
  return request({
    url: '/admin/Stock_target/init_targets',
    method: 'post',
    data
  })
}

// 获取目标库存修改日志
export function getChangeHistory(data) {
  return request({
    url: '/admin/Stock_target/get_change_history',
    method: 'get',
    params: data
  })
}

// 导出目标库存数据
export function exportTargetStock(data) {
  return request({
    url: '/admin/Stock_target/export_data',
    method: 'get',
    params: data,
    responseType: 'blob'
  })
}

// 移除单个商品
export function removeItem(data) {
  return request({
    url: '/admin/Stock_target/remove_item',
    method: 'post',
    data
  })
}

// 批量移除商品
export function batchRemoveItems(data) {
  return request({
    url: '/admin/Stock_target/batch_remove_items',
    method: 'post',
    data
  })
}

// 恢复单个商品
export function restoreItem(data) {
  return request({
    url: '/admin/Stock_target/restore_item',
    method: 'post',
    data
  })
}

// 批量恢复商品
export function batchRestoreItems(data) {
  return request({
    url: '/admin/Stock_target/batch_restore_items',
    method: 'post',
    data
  })
}

// 获取移除列表
export function getRemovedList(data) {
  return request({
    url: '/admin/Stock_target/get_removed_list',
    method: 'get',
    params: data
  })
}

// 获取移除商品统计
export function getRemovedInitInfo(data) {
  return request({
    url: '/admin/Stock_target/get_removed_init_info',
    method: 'get',
    params: data
  })
}




// WEBPACK FOOTER //
// ./src/api/inventoryFlow.js